import {getCookie, setCookie, eraseCookie} from '../helpers/CookieHelper';

export class AnnouncementComponent {
  container = null;

  constructor() {
    this.container = document.querySelector('.announcement-shortcode');
    if (!this.container) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    const button = this.container.querySelector('.js-announcement-btn');
    if (button) {
      button.addEventListener('click', (e) => this.buttonClickHandler(e));
    }
  }

  buttonClickHandler(e) {
    e.preventDefault();
    const target = e.target;

    const id = parseInt(this.container.getAttribute('data-id'));
    const cookie = getCookie('read_announcements');

    eraseCookie('read_announcements');

    const ids = cookie ? JSON.parse(cookie) : [];
    ids.push(id);

    setCookie('read_announcements', JSON.stringify(ids), 1);

    if (target.hasAttribute('href')) {
      window.location.href = target.getAttribute('href');
    }
  }
}